<template>
  <div class="input-v3">
    <label :for="id" v-if="label" class="input-v3_label">{{ label }}</label>
    <input
      :id="id"
      class="input-v3_input"
      :type="type"
      :placeholder="placeholder"
      :required="required"
      :value="modelValue"
      :maxlength="maxlength"
      @input="handleInput"
      ref="refInput"
      :name="name"
      :readonly="loading"
      />
      <div v-if="loading" class="input-v3_loader">
        <ac-preloader />
      </div>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import AcPreloader from '@ui-kit/components/AcPreloader.vue'

defineOptions({
  name: 'InputV3'
})

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
  required: {
    type: Boolean,
    default: false
  },
  maxlength: {
    type: Number
  },
  name: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

const id = ref(`input-v3-${Math.ceil(Math.random() * 1000)}`)
const refInput = ref<HTMLInputElement | null>(null)

const handleInput = (event: Event) => {
  if (props.type === 'number' && props.maxlength && refInput.value) {
    if (refInput.value.value.length >= props.maxlength) {
      refInput.value.value = refInput.value.value.slice(0, props.maxlength)
    }
  }
  emit('update:modelValue', (event.target as HTMLInputElement).value)
}

</script>

<style scoped lang="scss">
.input-v3 {
  width: 100%;
  border-radius: 22px;
  padding: 15px 14px;
  border: 1px solid var(--ac-color-light-gray);
  font-family: Inter;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;

  &_loader {
    width: 16px;
    height: 16px;
  }

  &_label {
    color: var(--ac-color-gray);
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0.018px;
    padding: 0 8px;
    background-color: var(--ac-color-white);
    overflow: visible;
    position: absolute;
    top: -6px;
  }

  &_input {
    width: 100%;
    border: 0;
    outline: none;
    background: transparent;
    color: var(--ac-color-black);
    caret-color: var(--ac-color-black);
    transition: color .3s;
    appearance: textfield;
    -moz-appearance: textfield;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    caret-color: var(--ac-color-deep-navy-blue);

    &:placeholder {
      color: var(--ac-color-gray);
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>
